import React from 'react'
import "./Telegram.css"

const Telegram = () => {
  return (
    <div className='mt-10 my-5 mx-auto'>
        
        <button class="button-85" role="button"> <a href="https://t.me/cw_botz">Click to Join Telegram</a></button>
    </div>
  )
}

export default Telegram
